import { LowerCasePipe, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, input, OnInit, output, signal } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { buttonStyle } from '@shared/components/button/config';
import { ButtonTheme } from '@shared/components/button/enum';
import { ButtonStyle } from '@shared/components/button/model';
import { GetStylePipe } from '@shared/components/button/pipe';
import { IconsDirective } from '@shared/directives';
import { AvailableIcons, Color, IconPosition, Size } from '@shared/enums';
import { Icon } from '@shared/models';

@Component({
  selector: 'app-button',
  imports: [IconsDirective, NgStyle, RouterLink, LowerCasePipe, GetStylePipe, NgTemplateOutlet],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements OnInit {
  readonly label = input.required<string>();
  readonly isDisabled = input(false);
  readonly isLoading = input(false);
  readonly size = input<keyof typeof Size>('NORMAL');
  readonly url = input<string>();
  readonly params = input<Params>();
  readonly icon = input<Icon>();
  readonly theme = input<keyof typeof ButtonTheme>('WHITE');
  readonly style = input<ButtonStyle>();
  readonly buttonClicked = output<string>();
  readonly isLink = computed(() => !!this.url());
  buttonStyle = signal<ButtonStyle>(null!);
  iconName = signal<keyof typeof AvailableIcons>(null!);
  iconPosition = signal<keyof typeof IconPosition>(null!);
  iconSize = signal<string>(null!);
  iconColor = signal<keyof typeof Color>(null!);
  readonly isExternalUrl = computed(() => !!this.url()?.startsWith('http'));

  constructor() {
    effect(() => {
      this.buttonStyle.set({ ...buttonStyle[ButtonTheme[this.theme()]], ...this.style() });
    });
  }

  ngOnInit(): void {
    const icon = this.icon();
    if (icon?.name) this.iconName.set(icon?.name);
    this.iconPosition.set(icon?.position ?? 'RIGHT');
    this.iconSize.set(icon?.size ?? '24px');
    this.iconColor.set(icon?.color ?? 'BLACK');
  }

  submit() {
    if (!this.isDisabled()) {
      this.buttonClicked.emit('button clicked');
    }
  }
}
